import ENV from "../env";

const generateInvoiceNumber = async ({ org, timestamp }) => {
  if (!org || !timestamp) {
    throw new Error("Missing organization or timestamp for invoice number generation");
  }

  const response = await fetch(`${ENV.firebaseApiUrl}/invoice/generate-number`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ org, timestamp }),
  });

  const resData = await response.json();

  if (!response.ok) {
    throw new Error(resData.message || "Failed to generate invoice number");
  }

  return resData.invoiceNumberInfo || null;
};

export default generateInvoiceNumber;
